import { render } from "./DocumentCard.vue?vue&type=template&id=2a4cfe52&scoped=true&ts=true&lang=pug"
import script from "./DocumentCard.vue?vue&type=script&lang=ts"
export * from "./DocumentCard.vue?vue&type=script&lang=ts"

import "./DocumentCard.vue?vue&type=style&index=0&id=2a4cfe52&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4cfe52"]])

export default __exports__